import { CartDTO, CartItemDTO, SupplierDTO } from '../modules/cart/types';
import { Api } from './Api';

export class CartsApi {
  static async getCarts() {
    return await Api.get('/orders/api/v1/cart');
  }

  static async getCart(id: string) {
    return await Api.get(`/carts/api/v1/cart/${id}`);
  }

  static async createCart(cart: CartDTO['order_items']) {
    return await Api.post('/orders/api/v1/orders', {
      order_items: cart,
    });
  }

  static async deleteCart(id: string) {
    return await Api.delete(`/carts/api/v1/carts/${id}`);
  }

  static async commitCart(id: string) {
    return await Api.post(`/orders/api/v1/orders/${id}/commit`);
  }

  static async addItems(items: CartItemDTO) {
    const data = {
      order_items: [items],
    };
    return await Api.post('/orders/api/v1/cart/add_items', data);
  }

  static async getCartItem(id: string) {
    return await Api.get(`/carts/api/v1/carts/items/${id}`);
  }

  // refundID upload atachment
  static async updateCartItem(id: string, item: Partial<CartItemDTO>) {
    const data = {
      comment: item.comment,
    };
    return await Api.patch(`/orders/api/v1/cart/${id}`, data);
  }

  static async deleteCartItem(id: string[]) {
    return await Api.post(`/orders/api/v1/cart/remove_items`, id);
  }

  /**
   * Поиск поставщиков с фильтрацией по параметрам.
   * @param params Объект с параметрами для фильтрации поставщиков.
   * @returns Promise с результатом поиска.
   */
  static async searchSuppliers(params: {
    price_gt?: number;
    price_lt?: number;
    delivery_term_gt?: number;
    delivery_term_lt?: number;
    brand?: string;
    supplier?: string;
    amount_gt?: number;
    name?: string;
    brand_article?: string;
    search_text?: string;
  }) {
    return await Api.get('/suppliers/api/v1/suppliers/search', params);
  }

  static async getSuppliers(): Promise<SupplierDTO[]> {
    const response = await Api.get<SupplierDTO[]>('/suppliers/api/v1/suppliers');
    return response.data;
  }
}
